import type { CandidateDirection, CandidateFamily, CandidateState } from '../../types/market';
import { Badge, type BadgeTone } from '../ui/Badge';

const familyLabels: Record<CandidateFamily, string> = {
  'hidden-recovery': 'Hidden recovery',
  'hidden-weakness': 'Hidden weakness',
  'early-expansion': 'Early expansion',
  'fresh-breakdown': 'Fresh breakdown',
  'failed-breakout': 'Failed breakout',
  'failed-breakdown': 'Failed breakdown',
  'pullback-continuation': 'Pullback continuation',
  'liquidation-exhaustion': 'Liquidation exhaustion',
  'historical-breakthrough': 'Historical breakthrough',
  'historical-rejection': 'Historical rejection',
  unclear: 'Unclear edge',
};

export function DirectionBadge({ direction }: { direction: CandidateDirection }): React.JSX.Element {
  const tone: BadgeTone = direction === 'long' ? 'positive' : direction === 'short' ? 'negative' : 'neutral';
  return <Badge tone={tone}>{direction === 'long' ? 'Potential long' : direction === 'short' ? 'Potential short' : 'No clear edge'}</Badge>;
}

export function StateBadge({ state }: { state: CandidateState }): React.JSX.Element {
  const tone: BadgeTone =
    state === 'strong' || state === 'confirming'
      ? 'positive'
      : state === 'weakening' || state === 'invalidated'
        ? 'negative'
        : state === 'developing'
          ? 'info'
          : state === 'observing' || state === 'detected'
            ? 'warning'
            : 'neutral';
  return <Badge tone={tone}>{state.replace('-', ' ')}</Badge>;
}

export function FamilyBadge({ family }: { family: CandidateFamily }): React.JSX.Element {
  return <Badge tone="neutral">{familyLabels[family]}</Badge>;
}
